<template>
  <el-col>
    <div v-if="item.deType === 0 || item.deType === 5">
      <el-radio-group
        v-model="filterType"
        size="mini"
        style="margin-bottom: 10px;"
        @change="filterTypeChange"
      >
        <el-radio label="logic">{{ $t('chart.logic_exp') }}</el-radio>
        <el-radio label="enum">{{ $t('chart.enum_exp') }}</el-radio>
      </el-radio-group>
    </div>

    <div
      v-if="((item.deType === 0 || item.deType === 5) && filterType === 'logic') || item.deType === 1 || item.deType === 2 || item.deType === 3"
    >
      <div style="display: inline-block;">
        <el-button
          icon="el-icon-plus"
          circle
          size="mini"
          style="margin-bottom: 10px;"
          @click="addFilter"
        />
        <el-radio-group
          v-show="item.filter && item.filter.length > 1"
          v-model="logic"
          size="mini"
          style="margin-left: 10px;"
          @change="logicChange"
        >
          <el-radio-button label="and">{{ $t('chart.and') }}</el-radio-button>
          <el-radio-button label="or">{{ $t('chart.or') }}</el-radio-button>
        </el-radio-group>
      </div>
      <div style="max-height: 50vh;overflow-y: auto;">
        <el-row v-for="(f,index) in item.filter" :key="index" class="filter-item">
          <el-col :span="5" style="margin-right: 10px;">
            <span>{{ item.name }}</span>
          </el-col>
          <el-col :span="4" style="margin-right: 10px;">
            <el-select v-model="f.term" size="mini">
              <el-option-group v-for="(group,idx) in options" :key="idx" :label="group.label">
                <el-option
                  v-for="opt in group.options"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-option-group>
            </el-select>
          </el-col>
          <el-col :span="10">
            <el-input
              v-show="!f.term.includes('null') && !f.term.includes('empty')"
              v-model="f.value"
              class="value-item"
              :placeholder="$t('chart.condition')"
              size="mini"
              clearable
            />
          </el-col>
          <el-tooltip
            class="item"
            effect="dark"
            content="SQL函数：按照[DATE_SUB()]格式"
            placement="bottom-end"
          >
            <svg
              t="1696661085842"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5873"
              width="15"
              height="15"
              style="margin-left: 10px;"
            >
              <path
                d="M521.309091 698.181818c18.618182 0 34.909091 16.290909 34.909091 34.909091v23.272727c0 18.618182-16.290909 34.909091-34.909091 34.909091s-34.909091-16.290909-34.909091-34.909091v-23.272727c0-18.618182 13.963636-34.909091 34.909091-34.909091z m-139.636364-290.909091c-18.618182 0-32.581818-13.963636-32.581818-32.581818v-4.654545c0-4.654545 2.327273-9.309091 2.327273-13.963637 13.963636-86.109091 86.109091-146.618182 172.218182-146.618182h6.981818c76.8 0 144.290909 53.527273 162.909091 130.327273v4.654546c16.290909 74.472727-11.636364 148.945455-72.145455 195.490909l-62.836363 46.545454c-2.327273 2.327273-4.654545 4.654545-4.654546 9.309091v23.272727c0 18.618182-16.290909 34.909091-34.909091 34.909091s-34.909091-16.290909-34.909091-34.909091v-23.272727c0-25.6 11.636364-51.2 32.581818-65.163636l62.836364-46.545455c37.236364-27.927273 55.854545-76.8 44.218182-123.345454v-4.654546c-9.309091-44.218182-48.872727-76.8-95.418182-76.8h-6.981818c-51.2 0-95.418182 37.236364-102.4 88.436364v6.981818c-2.327273 18.618182-18.618182 32.581818-37.236364 32.581818zM512 1024C228.072727 1024 0 795.927273 0 512S228.072727 0 512 0s512 228.072727 512 512-228.072727 512-512 512z m0-46.545455c256 0 465.454545-209.454545 465.454545-465.454545S768 46.545455 512 46.545455 46.545455 256 46.545455 512s209.454545 465.454545 465.454545 465.454545z"
                fill="#333333"
                p-id="5874"
              />
            </svg>
          </el-tooltip>

          <el-button
            type="text"
            icon="el-icon-delete"
            circle
            style="float: right"
            @click="removeFilter(index)"
          />
        </el-row>
      </div>
    </div>

    <div v-if="(item.deType === 0 || item.deType === 5) && filterType === 'enum'">
      <span style="margin-right: 10px;">{{ $t('chart.filter_exp') }}</span>
      <el-select
        v-model="enumCheckField"
        filterable
        collapse-tags
        multiple
        :placeholder="$t('chart.pls_slc')"
        size="mini"
        @change="enumChange"
      >
        <el-option
          v-for="field in fieldOptions"
          :key="field.id"
          :label="field.text"
          :value="field.id"
        />
      </el-select>
    </div>
  </el-col>
</template>

<script>
import { multFieldValues } from "@/api/dataset/dataset";

export default {
  name: "ResultFilterEditor",
  props: {
    chart: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      textOptions: [
        {
          label: "",
          options: [
            {
              value: "eq",
              label: this.$t("chart.filter_eq")
            },
            {
              value: "not_eq",
              label: this.$t("chart.filter_not_eq")
            }
          ]
        },
        {
          label: "",
          options: [
            {
              value: "like",
              label: this.$t("chart.filter_like")
            },
            {
              value: "not like",
              label: this.$t("chart.filter_not_like")
            }
          ]
        },
        {
          label: "",
          options: [
            {
              value: "null",
              label: this.$t("chart.filter_null")
            },
            {
              value: "not_null",
              label: this.$t("chart.filter_not_null")
            }
          ]
        },
        {
          label: "",
          options: [
            {
              value: "empty",
              label: this.$t("chart.filter_empty")
            },
            {
              value: "not_empty",
              label: this.$t("chart.filter_not_empty")
            }
          ]
        }
      ],
      dateOptions: [
        {
          label: "",
          options: [
            {
              value: "eq",
              label: this.$t("chart.filter_eq")
            },
            {
              value: "not_eq",
              label: this.$t("chart.filter_not_eq")
            }
          ]
        },
        {
          label: "",
          options: [
            {
              value: "lt",
              label: this.$t("chart.filter_lt")
            },
            {
              value: "gt",
              label: this.$t("chart.filter_gt")
            }
          ]
        },
        {
          label: "",
          options: [
            {
              value: "le",
              label: this.$t("chart.filter_le")
            },
            {
              value: "ge",
              label: this.$t("chart.filter_ge")
            }
          ]
        }
      ],
      valueOptions: [
        {
          label: "",
          options: [
            {
              value: "eq",
              label: this.$t("chart.filter_eq")
            },
            {
              value: "not_eq",
              label: this.$t("chart.filter_not_eq")
            }
          ]
        },
        {
          label: "",
          options: [
            {
              value: "lt",
              label: this.$t("chart.filter_lt")
            },
            {
              value: "gt",
              label: this.$t("chart.filter_gt")
            }
          ]
        },
        {
          label: "",
          options: [
            {
              value: "le",
              label: this.$t("chart.filter_le")
            },
            {
              value: "ge",
              label: this.$t("chart.filter_ge")
            }
          ]
        }
      ],
      options: [],
      logic: "",
      filterType: "",
      enumCheckField: [],
      fieldOptions: []
    };
  },
  watch: {
    item: function() {
      this.initOptions();
    }
  },
  mounted() {
    this.initOptions();
    this.init();
    this.initEnumOptions();
  },
  methods: {
    initOptions() {
      if (this.item) {
        if (this.item.deType === 0 || this.item.deType === 5) {
          this.options = JSON.parse(JSON.stringify(this.textOptions));
        } else if (this.item.deType === 1) {
          this.options = JSON.parse(JSON.stringify(this.dateOptions));
        } else {
          this.options = JSON.parse(JSON.stringify(this.valueOptions));
        }
      }
    },
    init() {
      this.logic = this.item.logic;
      this.filterType = this.item.filterType;
      this.enumCheckField = this.item.enumCheckField;
    },
    initEnumOptions() {
      // 查找枚举值
      if (this.item.deType === 0 || this.item.deType === 5) {
        multFieldValues({ fieldIds: [this.item.id] }).then(res => {
          this.fieldOptions = this.optionData(res.data);
        });
      }
    },
    optionData(data) {
      if (!data) return null;
      return data
        .filter(item => !!item)
        .map(item => {
          return {
            id: item,
            text: item
          };
        });
    },
    addFilter() {
      this.item.filter.push({
        fieldId: this.item.id,
        term: "eq",
        value: ""
      });
    },
    removeFilter(index) {
      this.item.filter.splice(index, 1);
    },
    logicChange(val) {
      this.item.logic = val;
    },
    filterTypeChange(val) {
      this.item.filterType = val;
    },
    enumChange(val) {
      this.item.enumCheckField = this.enumCheckField;
    }
  }
};
</script>

<style scoped>
.filter-item {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 4px 4px 4px 14px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-item ::v-deep .el-form-item__label {
  font-size: 12px;
}
span {
  font-size: 12px;
}

.value-item ::v-deep .el-input {
  position: relative;
  display: inline-block;
  width: 80px !important;
}
</style>
